export const extractCompanyNameFromEmail = (email: string | undefined) => {
  if (!email) {
    return ''
  }

  const emailParts = email.split('@')
  if (emailParts.length > 1) {
    const domain = emailParts[1]
    const companyName = domain.split('.')[0]
    return companyName
  }
  return ''
}
